import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@4.3.0@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-yuancheng",
  "use": "icon-yuancheng-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-yuancheng\"><defs><style type=\"text/css\"></style></defs><path d=\"M913.8 793.4H640.7v70.7l57.5 56.6v14.1H324.4v-14.2l57.5-56.5v-70.7H108.7c-23.8 0-43.1-19-43.1-42.4V185.5c0-23.4 19.3-42.4 43.1-42.4h266.2l-57.5 56.5H123.1v480.7h776.3V199.6H705.1l-57.5-56.5h266.2c23.8 0 43.1 19 43.1 42.4V751c0 23.4-19.3 42.4-43.1 42.4zM611.9 270.3c-11.5 0-22.5-4.5-30.5-12.4l-27-26.6v194.5c0 23.5-19.3 42.4-43.2 42.4-23.8 0-43.1-19-43.1-42.4V231.4l-27 26.5c-11 10.9-26.9 15.2-41.8 11.3-14.9-3.8-26.6-15.3-30.6-30.2-4-14.7 0.4-30.4 11.5-41.1L480.8 99c17-16.6 44-16.6 61 0l100.7 99c12.3 12.1 16 30.4 9.3 46.2-6.9 15.9-22.6 26.2-39.9 26.1z m0 0\" p-id=\"9332\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/yuancheng.svg
// module id = Hgxa
// module chunks = 167